import React from 'react'


export default class PurchaseTotal extends React.Component {

  render() {


    let total = 0.00,cessRow, tcsRow, totalPrice=0.00, totalTax=0.00, totalDiscount=0.00

    if(typeof this.props.purchase !=="undefined") {

      let purchase = this.props.purchase
      totalPrice = purchase.totalPrice
      totalDiscount = purchase.totalDiscount
      totalTax = purchase.totalTax
      total = purchase.total

      if(purchase.add_cess) {
        cessRow = <tr><td>Cess </td><td>&nbsp;{purchase.totalCess}</td></tr>
      }
      if (purchase.add_tcs) {
        tcsRow = <tr><td>TCS </td><td>&nbsp;{purchase.totalTcs}</td></tr>
      }
    }



    return (<table className="table">
                  <tbody>
                  <tr><td>Amount</td><td>&nbsp;{totalPrice}</td></tr>
                  <tr><td>Discount</td><td>-{totalDiscount}</td></tr>
                  <tr><td>GST</td><td>&nbsp;{totalTax}</td></tr>
                  {cessRow}
                  {tcsRow}
                  <tr><td>Total</td><td>&nbsp;{total}</td></tr>
                  </tbody>
                </table>)
  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/rowelements/purchasetotal.js